module.exports = __webpack_public_path__ + "static/vid-mobile-control-19e5433234d7f013a1ab1612d8241c22.mp4";